require('./aggregatorBeta.scss');

import React from 'react';
import PropTypes from 'prop-types';

import OKTooltip from 'components/commons/OKTooltip/OKTooltip';
const { formatText, FormattedText } = require('core/i18n').i18n;

const infoIcon = require('assets/images/info-icon.png');

const AggregatorBeta = (props) => {
    const { tooltipTextKey } = props
    const tooltipText = <FormattedText value={tooltipTextKey}/>

    const beta = (
        <span className="aggregator-beta">
            <span className="aggregator-beta__text">
                {formatText('aggregatorBeta-text')}
            </span>
            <span className="aggregator-beta__div-icon">
                <img src={infoIcon} className="aggregator-beta__icon"/>
            </span>
        </span>
    )

    return (
        <OKTooltip
            content={tooltipText}
            modifier="dark-bg"
            target={beta}
            type="custom"
        />
    )
}

AggregatorBeta.propTypes = {
    tooltipTextKey: PropTypes.string
}


export { AggregatorBeta };
